import {fold} from 'fp-ts/Either';
import {pipe} from 'fp-ts/function';

import {Language, LanguageSchema} from 'api/gen/Language';
import {i18n} from 'app/translations/i18n';

import {isLocalStorageAvailable} from './is-local-storage-available';

const languageLocalStorageName = 'i18nextLng';

/** Stores the current language setting across sessions. */
class LanguageStore {
    public get(): Language | undefined {
        if (!isLocalStorageAvailable()) return undefined;

        const cookieValue = localStorage.getItem(languageLocalStorageName);

        return pipe(
            LanguageSchema.decode(cookieValue),
            fold(
                () => undefined,
                language => language,
            ),
        );
    }

    public set(value: Language): void {
        i18n.changeLanguage(value)
            .catch((err => {
                // eslint-disable-next-line no-console
                console.log(err);
            }));
    }
}

/** Shared language store used by the app to read and update the active locale. */
export const languageStore = new LanguageStore();
